{
  "billing": {
    "title": "Faturamento",
    "page_title": "Faturamento e planos",
    "page_content": "Você pode alterar e gerenciar seu plano de assinatura e editar seus detalhes de pagamento.",
    "in_arrears_error": {
      "title": "Método de pagamento ausente ou inválido",
      "content": "Sua conta está suspensa no momento. Atualize seus detalhes de pagamento para ativar sua conta"
    },
    "cancelled_error_payed": {
      "title": "A assinatura atual foi cancelada",
      "content_1": "Sua conta foi cancelada. Por favor",
      "content_2": "entre em contato conosco",
      "content_3": "para reativar sua conta"
    },
    "cancelled_error_trial": {
      "title": "Seu período de teste acabou",
      "content": "Sua conta foi cancelada. Altere seu plano para um plano pago para continuar usando o Iventis."
    },
    "subscription_box": {
      "title": "Assinatura",
      "current_plan": "Plano atual",
      "next_payment": "Próximo pagamento",
      "renews_on": "Renova em",
      "paid": "Pago",
      "days": "para ir",
      "get_in_touch": "Entre em contato para discutir seu plano",
      "Trial": "Ensaio",
      "Active": "Ativo",
      "Cancelled": "Cancelado",
      "InArrears": "Em atraso"
    },
    "change_plan": "Plano de mudança",
    "payment_details_box": {
      "title": "Detalhes do pagamento",
      "payment_method": "Método de pagamento",
      "card_ending": "Cartão terminando em",
      "expires": "Expira",
      "billing_address": "Endereço de cobrança",
      "no_payment_method": "Sem método de pagamento",
      "payment_breakdown_project": "{{ amount }} (1 projeto x {{ amount }}",
      "payment_breakdown_users": "{{ totalAmount }} {{ maxUsers }} usuários x {{ userAmount }}",
      "payment_breakdown_user": "{{ totalAmount }} (1 usuário x {{ totalAmount }}",
      "users": "usuários",
      "user": "usuária",
      "discount": "desconto"
    },
    "redirect_modal": {
      "title": "Editar forma de pagamento",
      "content": "Você será redirecionado ao nosso provedor de cobrança para editar seus detalhes de pagamento."
    },
    "excludes_taxes": "Exclui quaisquer impostos aplicáveis"
  },
  "upgrade_plan_warnings": {
    "upgrade_plan": "Plano de upgrade",
    "contact_us": "Entre em contato conosco",
    "view_plans": "Exibir planos"
  },
  "view_plans": "Exibir planos",
  "subscription_details": {
    "title": "Detalhes da assinatura",
    "selected_plan": "Plano selecionado",
    "plan_type": "Tipo de plano",
    "currency": "Moeda",
    "billed": "Faturado",
    "payment_date": "Data de pagamento",
    "payment_date_desc": {
      "Monthly": "{{ date }} de cada mês",
      "Annually": "{{ date }}"
    },
    "renewal_date": "Data de renovação",
    "add_users": "Adicionar usuários",
    "add_payment_method": "Adicionar forma de pagamento",
    "cannot_switch_from_annual": "Entre em contato conosco se precisar mudar do faturamento anual para o mensal",
    "exceeded_max_users_message": "Entre em contato conosco para discutir suas necessidades se precisar de mais de {{ numberOfUsers }} usuários",
    "continue_to_payment": "Continuar com o pagamento",
    "redirect_modal": {
      "title": "Editar assinatura",
      "message": "Ao clicar em continuar, você será redirecionado ao nosso provedor de cobrança para fazer os pagamentos necessários para a assinatura atualizada"
    },
    "update_successful": "Assinatura atualizada com sucesso"
  },
  "subscription_price_breakdown": {
    "title": "Detalhamento de preços",
    "subscription_fee": "Taxa de assinatura",
    "individual_price_breakdown": "Detalhamento individual de preços",
    "discount_applied": "Desconto aplicado",
    "discount_has_been_applied": "Um desconto de {{ discount }} foi aplicado automaticamente à sua conta",
    "total": "Total",
    "frequency_proice_breakdown": "{{ frequency }} detalhamento de preços",
    "frequency": {
      "Monthly": "Mensalmente",
      "Annually": "Anualmente"
    },
    "time_unit": {
      "Monthly": "meses",
      "Annually": "ano"
    },
    "users": "usuários",
    "excludes_taxes": "Exclui quaisquer impostos aplicáveis que serão adicionados na página de pagamento"
  },
  "subscription_payment_breakdown": {
    "title": "Detalhamento do pagamento",
    "vat": "IVA {{ percentage }} em {{ total }}",
    "total_excluding_tax": "Total excluindo impostos",
    "amount_due": "Quantia devida",
    "description": "Descrição",
    "total": "Total",
    "unit": "Unidade",
    "pay": "Pague {{ amount }}"
  },
  "order_summary": "Resumo do pedido",
  "settings": "Configurações"
}